{
  "fr": {
    "analytics": {
      "labels": {
        "click_seen_by": "Cliquer pour voir quels clients l'ont vu",
        "click_shared_with": "Cliquer pour savoir avec quels clients cela est partagé",
        "deleted": "Supprimé",
        "deleted_item": "Cet élément a été supprimé et n'est plus cliquable",
        "noCustomers": "Aucun client n'est encore affecté à ce niveau.",
        "noCustomersSeen": "Aucun client ne l'a encore vu.",
        "noCustomersUnseen": "Tous les clients ont vu cela",
        "noUnitAccess": "Pas d'accès à l'unité",
        "notSeen": "Pas vue ({number})",
        "seen": "Vue ({number})",
        "seenBy": "Vu par",
        "sharedWithMultipleUnits": "Partagé avec zero clients dans {level_name} | Partagé avec 1 client dans {level_name} | Partagé avec {customers_count} clients dans {level_name}",
        "sharedWithUnit": "Partagé avec {unit_name}",
        "units": "Pas d'Unité | Une Unité | {count} Unités",
        "views": "Vues",
        "viewsCount": "Pas de Vues | 1 Vue | {count} Vues"
      }
    }
  }
}
